module.exports = __webpack_public_path__ + "img/caso6.7e28220d.jpg";